import {KeyPath} from "../types/types";

export const mapLabelByKey = {
    [KeyPath.PAGE]: 'Выгрузить в эксель с учетом фильтров',
    [KeyPath.ALL_BY_SETTINGS]: 'Выгрузить в эксель все записи с учетом настроек таблицы',
    [KeyPath.ALL]: 'Выгрузить в эксель все записи и все столбцы',
}

